/**
 * Failure copy for a mutation.
 *
 * `apiRequest` turns every HTTP failure into an `ApiError`, but a request that never
 * produced a response - an offline browser, an aborted fetch - rejects with
 * something else entirely. A page that only renders `ApiError` therefore shows
 * nothing at all for a network failure, which reads as a successful save.
 */

import type { TFunction } from 'i18next'

import { ApiError } from './api'
import { apiErrorText } from './errors'

/** Message to show for a failed mutation, whatever shape the failure has. */
export function mutationErrorText(error: unknown, t: TFunction): string | null {
  if (error === null || error === undefined) {
    return null
  }
  if (error instanceof ApiError) {
    return apiErrorText(error, t)
  }
  return t('error.internal_error')
}
